import { createAction, props } from '@ngrx/store';
// Hubspot Deals

export const getHubspotDeals = createAction(
  '[Hubspot] Get Hubspot Deals',
  props<{ contact_id: number; search_id: number }>()
);

export const getHubspotDealsSuccess = createAction(
  '[Hubspot] Get Hubspot Deals  Success',
  props<{ hubspot_deals: any }>()
);

export const getHubspotDealsFailure = createAction(
  '[Hubspot] Get Hubspot Deals Failure',
  props<{ error: any }>()
);

export const showMoreHubspotDeals = createAction(
  '[Hubspot] Show More Hubspot Deals',
  props<{ contact_id: any; search_id: any; page: number }>()
);

export const showMoreHubspotDealsSuccess = createAction(
  '[Hubspot] Show More Hubspot Deals  Success',
  props<{ hubspot_deals: any }>()
);

export const showMoreHubspotDealsFailure = createAction(
  '[Hubspot] Show More Hubspot Deals Failure',
  props<{ error: any }>()
);

// Hubspot Contact

export const getHubspotContact = createAction(
  '[Hubspot] Get Hubspot Contact',
  props<{ search_id: number }>()
);

export const getHubspotContactSuccess = createAction(
  '[Hubspot] Get Hubspot Contact  Success',
  props<{ hubspot_contact: any }>()
);

export const getHubspotContactFailure = createAction(
  '[Hubspot] Get Hubspot Contact Failure',
  props<{ error: any }>()
);

// Hubspot Company

export const getHubspotCompany = createAction(
  '[Hubspot] Get Hubspot Company',
  props<{ contact_id; search_id: number }>()
);

export const getHubspotCompanySuccess = createAction(
  '[Hubspot] Get Hubspot Company  Success',
  props<{ hubspot_company: any }>()
);

export const getHubspotCompanyFailure = createAction(
  '[Hubspot] Get Hubspot Company Failure',
  props<{ error: any }>()
);

export const getHubspotCompanies = createAction(
  '[Hubspot] Get Hubspot Companies',
  props<{ search_id: number }>()
);

export const getHubspotCompaniesSuccess = createAction(
  '[Hubspot] Get Hubspot Companies  Success',
  props<{ hubspot_companies: any }>()
);

export const getHubspotCompaniesFailure = createAction(
  '[Hubspot] Get Hubspot Companies Failure',
  props<{ error: any }>()
);

export const getHubspotCompanyLifeCycleStages = createAction(
  '[Hubspot] Get Hubspot Company Life Cycle Stage',
  props<{ search_id: number }>()
);

export const getHubspotCompanyLifeCycleStagesSuccess = createAction(
  '[Hubspot] Get Company Life Cycle Stage  Success',
  props<{ hubspot_company_life_cycle_stages: any }>()
);

export const getHubspotCompanyLifeCycleStagesFailure = createAction(
  '[Hubspot] Get Hubspot Company Life Cycle Stage Failure',
  props<{ error: any }>()
);

export const getHubspotCompanyIndustries = createAction(
  '[Hubspot] Get Hubspot Company Industries',
  props<{ search_id: number }>()
);

export const getHubspotCompanyIndustriesSuccess = createAction(
  '[Hubspot] Get Company Industries  Success',
  props<{ hubspot_company_industries: any }>()
);

export const getHubspotCompanyIndustriesFailure = createAction(
  '[Hubspot] Get Hubspot Company Industries Failure',
  props<{ error: any }>()
);

export const getHubspotDealOwners = createAction(
  '[Hubspot] Get Hubspot Deal Owners',
  props<{ search_id: number }>()
);

export const getHubspotDealOwnersSuccess = createAction(
  '[Hubspot] Get Deal Owners  Success',
  props<{ hubspot_deal_owners: any }>()
);

export const getHubspotDealOwnersFailure = createAction(
  '[Hubspot] Get Hubspot Deal Owners Failure',
  props<{ error: any }>()
);

export const getHubspotDealPipelines = createAction(
  '[Hubspot] Get Hubspot Deal Pipelines',
  props<{ search_id: number }>()
);

export const getHubspotDealPipelinesSuccess = createAction(
  '[Hubspot] Get Deal Pipelines  Success',
  props<{ hubspot_deal_pipelines: any }>()
);

export const getHubspotDealPipelinesFailure = createAction(
  '[Hubspot] Get Hubspot Deal Pipelines Failure',
  props<{ error: any }>()
);

export const getHubspotDealStages = createAction(
  '[Hubspot] Get Hubspot Deal Stages',
  props<{ search_id: number; pipeline: any }>()
);

export const getHubspotDealStagesSuccess = createAction(
  '[Hubspot] Get Deal Stages  Success',
  props<{ hubspot_deal_stages: any }>()
);

export const getHubspotDealStagesFailure = createAction(
  '[Hubspot] Get Hubspot Deal Stages Failure',
  props<{ error: any }>()
);

export const HubspotNewContact = createAction(
  '[Hubspot] Hubspot New Contact',
  props<{ user_id: any; name: any; mail: any; company: any; phone: any }>()
);

export const HubspotNewContactSuccess = createAction(
  '[Hubspot] Hubspot New Contact Success',
  props<{ hubspot_new_contact: any }>()
);

export const HubspotNewContactFailure = createAction(
  '[Hubspot] Hubspot New Contact Failure',
  props<{ error: string }>()
);

export const HubspotNewCompany = createAction(
  '[Hubspot] Hubspot New Company',
  props<{
    user_id: any;
    company_name: any;
    company_domain: any;
    company_industry: any;
    company_city: any;
    company_phone: any;
    company_state;
    company_life_cycle_stage;
    contact_id;
  }>()
);

export const HubspotNewCompanySuccess = createAction(
  '[Hubspot] Hubspot New Company Success',
  props<{ hubspot_new_company: any }>()
);

export const HubspotNewCompanyFailure = createAction(
  '[Hubspot] Hubspot New Company Failure',
  props<{ error: string }>()
);

export const hubspotNewDeal = createAction(
  '[Hubspot] Hubspot New Deal',
  props<{ user_id: any; properties: any; contact_id: number }>()
);

export const hubspotNewDealSuccess = createAction(
  '[Hubspot] Hubspot New Deal Success',
  props<{ hs_object: any }>()
);

export const hubspotNewDealFailure = createAction(
  '[Hubspot] Hubspot New Deal Failure',
  props<{ error: string }>()
);
export const clearHubspot = createAction('[Hubspot] Clear Hubspot');
